import { render, staticRenderFns } from "./AIAgent.VoiceControls.vue?vue&type=template&id=2516ba3e&lang=pug"
import script from "./AIAgent.VoiceControls.vue?vue&type=script&lang=js"
export * from "./AIAgent.VoiceControls.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.VoiceControls.vue?vue&type=style&index=0&id=2516ba3e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports